import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  FormGroup,
} from "reactstrap";
import Select from "react-select";
import { Colxx } from "../../components/common/CustomBootstrap";
import { AddCommaNumber } from "../../helpers/Utils";

const ShippingAddressModal = ({
  isOpen,
  toggle,
  shipping_provider,
  receiver_address,
  receiver_province,
  receiver_district,
  receiver_ward,
  provinces,
  districts,
  wards,
  shipping_fee,
  is_calculating_fee,
  onSelectShippingAddress,
  onChangeShipping,
  handleCalculateFee,
  connected_providers,
  shipping_receiver_name,
  shipping_receiver_phone,
  shipping_cod,
  shipping_cod_amount,
  shipping_free,
  shipping_weight,
  shipping_length,
  shipping_width,
  shipping_height,
  shipping_note,
  shipping_required_note,
}) => {
  const providerName =
    connected_providers.find((p) => p.provider === shipping_provider)?.name ||
    shipping_provider;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Thông tin giao hàng - {providerName}
      </ModalHeader>
      <ModalBody>
        <div className="shipping-form p-3">
          {/* Hàng 1: Tên và Số điện thoại người nhận */}
          <Row className="mb-3">
            <Colxx md="6" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Tên người nhận</Label>
                <Input
                  type="text"
                  name="shipping_receiver_name"
                  placeholder="Nhập tên người nhận"
                  value={shipping_receiver_name || ""}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="6" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Số điện thoại nhận</Label>
                <Input
                  type="text"
                  name="shipping_receiver_phone"
                  placeholder="Nhập số điện thoại"
                  value={shipping_receiver_phone || ""}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hàng 2: Địa chỉ chi tiết */}
          <Row className="mb-3">
            <Colxx xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">
                  Địa chỉ chi tiết (Số nhà, tên đường...)
                </Label>
                <Input
                  type="text"
                  name="receiver_address"
                  placeholder="Ví dụ: 123 Nguyễn Huệ"
                  value={receiver_address}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hàng 3: Tỉnh/Thành, Quận/Huyện, Phường/Xã */}
          <Row className="mb-3">
            <Colxx md="4" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Tỉnh/Thành</Label>
                <Select
                  className="react-select"
                  classNamePrefix="react-select"
                  options={provinces.map((p) => ({
                    value: p.ProvinceID || p.id,
                    label: p.ProvinceName || p.name,
                  }))}
                  value={receiver_province}
                  onChange={(val) =>
                    onSelectShippingAddress("receiver_province", val)
                  }
                  placeholder="Chọn Tỉnh/Thành"
                />
              </FormGroup>
            </Colxx>
            <Colxx md="4" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Quận/Huyện</Label>
                <Select
                  className="react-select"
                  classNamePrefix="react-select"
                  options={districts.map((d) => ({
                    value: d.DistrictID || d.id,
                    label: d.DistrictName || d.name,
                  }))}
                  value={receiver_district}
                  onChange={(val) =>
                    onSelectShippingAddress("receiver_district", val)
                  }
                  placeholder="Chọn Quận/Huyện"
                  isDisabled={!receiver_province}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="4" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Phường/Xã</Label>
                <Select
                  className="react-select"
                  classNamePrefix="react-select"
                  options={wards.map((w) => ({
                    value: w.WardCode || w.id,
                    label: w.WardName || w.name,
                  }))}
                  value={receiver_ward}
                  onChange={(val) =>
                    onSelectShippingAddress("receiver_ward", val)
                  }
                  placeholder="Chọn Phường/Xã"
                  isDisabled={!receiver_district}
                />
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hàng 4: Miễn phí vận chuyển & Thu hộ (COD) */}
          <Row className="mb-3">
            <Colxx md="6" xxs="12">
              <FormGroup className="d-flex align-items-center mt-4">
                <Input
                  type="checkbox"
                  id="shipping_free"
                  name="shipping_free"
                  checked={!!shipping_free}
                  onChange={onChangeShipping}
                  className="mr-2 position-static"
                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                />
                <Label for="shipping_free" className="font-weight-bold mb-0 cursor-pointer ml-2">
                  Miễn phí vận chuyển (Shop trả phí)
                </Label>
              </FormGroup>
            </Colxx>
            <Colxx md="6" xxs="12">
              <FormGroup className="d-flex align-items-center mt-4">
                <Input
                  type="checkbox"
                  id="shipping_cod"
                  name="shipping_cod"
                  checked={!!shipping_cod}
                  onChange={onChangeShipping}
                  className="mr-2 position-static"
                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                />
                <Label for="shipping_cod" className="font-weight-bold mb-0 cursor-pointer ml-2">
                  Thu hộ tiền mặt (COD)
                </Label>
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hàng 5: Nhập số tiền thu hộ (Hiển thị khi bật COD) */}
          {shipping_cod && (
            <Row className="mb-3">
              <Colxx md="6" xxs="12">
                <FormGroup>
                  <Label className="font-weight-bold">Số tiền thu hộ (VNĐ)</Label>
                  <Input
                    type="number"
                    name="shipping_cod_amount"
                    placeholder="Nhập số tiền thu hộ"
                    value={shipping_cod_amount !== undefined ? shipping_cod_amount : ""}
                    onChange={onChangeShipping}
                  />
                </FormGroup>
              </Colxx>
            </Row>
          )}

          {/* Hàng 6: Trọng lượng & Kích thước gói hàng */}
          <Row className="mb-3">
            <Colxx md="3" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Trọng lượng (gram)</Label>
                <Input
                  type="number"
                  name="shipping_weight"
                  placeholder="500"
                  value={shipping_weight !== undefined ? shipping_weight : 500}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="3" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Chiều dài (cm)</Label>
                <Input
                  type="number"
                  name="shipping_length"
                  placeholder="20"
                  value={shipping_length !== undefined ? shipping_length : 20}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="3" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Chiều rộng (cm)</Label>
                <Input
                  type="number"
                  name="shipping_width"
                  placeholder="20"
                  value={shipping_width !== undefined ? shipping_width : 20}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="3" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Chiều cao (cm)</Label>
                <Input
                  type="number"
                  name="shipping_height"
                  placeholder="10"
                  value={shipping_height !== undefined ? shipping_height : 10}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hàng 7: Ghi chú giao hàng & Lưu ý xem hàng */}
          <Row className="mb-3">
            <Colxx md="6" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Ghi chú giao hàng</Label>
                <Input
                  type="text"
                  name="shipping_note"
                  placeholder="Ví dụ: Giao giờ hành chính"
                  value={shipping_note || ""}
                  onChange={onChangeShipping}
                />
              </FormGroup>
            </Colxx>
            <Colxx md="6" xxs="12">
              <FormGroup>
                <Label className="font-weight-bold">Lưu ý xem hàng</Label>
                <Input
                  type="select"
                  name="shipping_required_note"
                  value={shipping_required_note || "CHOXEMHANGKHONGTHU"}
                  onChange={onChangeShipping}
                >
                  <option value="CHOXEMHANGKHONGTHU">Cho xem hàng không cho thử</option>
                  <option value="CHOTHUHANG">Cho thử hàng</option>
                  <option value="KHONGCHOXEMHANG">Không cho xem hàng</option>
                </Input>
              </FormGroup>
            </Colxx>
          </Row>

          {/* Hộp hiển thị phí ship */}
          <div className="d-flex justify-content-between align-items-center mt-4 p-3 border border-radius bg-light">
            <div>
              <span className="h5 mb-0 text-primary font-weight-bold">
                Phí vận chuyển dự kiến:
              </span>
              <span className="h5 mb-0 ml-2 font-weight-bold">
                {is_calculating_fee
                  ? " Đang tính..."
                  : ` ${AddCommaNumber(shipping_fee)} VNĐ`}
              </span>
            </div>
            <Button
              color="info"
              size="sm"
              onClick={handleCalculateFee}
              disabled={is_calculating_fee || !receiver_ward}
            >
              <i className="simple-icon-calculator mr-2" />
              Tính lại phí ship
            </Button>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          Bỏ qua
        </Button>
        <Button
          color="primary"
          onClick={toggle}
          disabled={
            !receiver_ward ||
            !receiver_address ||
            !receiver_address.trim() ||
            !shipping_receiver_name ||
            !shipping_receiver_name.trim() ||
            !shipping_receiver_phone ||
            !shipping_receiver_phone.trim()
          }
        >
          Xác nhận
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ShippingAddressModal;
